import Vue from 'vue'
import Router from 'vue-router'
import legalStatement from '../page/legalStatement/legalStatement'

Vue.use(Router)

const indexPage = resolve => require(['../page/index/index.vue'], resolve)
const soultion = resolve => require(['../page/soultion/soultion.vue'], resolve)
const aboutus = resolve => require(['../page/aboutus/aboutus.vue'], resolve)
const buildPlan = resolve => require(['../page/buildPlan/buildPlan.vue'], resolve)
const culture = resolve => require(['../page/culture/culture.vue'], resolve)
const contactUs = resolve => require(['../page/contactUs/contactUs.vue'], resolve)
const service = resolve => require(['../page/service/service.vue'], resolve)
const news = resolve => require(['../page/news/news.vue'], resolve)
const info = resolve => require(['../page/info/info.vue'], resolve)
const product = resolve => require(['../page/product/product.vue'], resolve)
const joinUs = resolve => require(['../page/joinUs/joinUs.vue'], resolve)
const groupnews = resolve => require(['../page/groupNews/groupnews.vue'], resolve)
export default new Router({
 //mode: 'history', // 去掉url中的#
 // scrollBehavior: () => ({ y: 0 }),
  routes: [
    // 首页
    {
      path: '/',
      name: 'indexPage',
      component: indexPage
    },
    // 解决方案
    {
      path: '/soultion',
      name: 'soultion',
      component: soultion
    },
    // 关于我们
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    // 建站方案
    {
      path: '/buildPlan',
      name: 'buildPlan',
      component: buildPlan
    },
    // 客户案例
    {
      path: '/culture',
      name: 'culture',
      component: culture
    },
    // 联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/info',
      name: 'info',
      component: info
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs
    },
    {
      path: '/groupnews',
      name: 'groupnews',
      component: groupnews
    },
    {
      path: '/legalStatement',
      name: 'legalStatement',
      component: legalStatement
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js